import React, { useReducer, createContext} from 'react';
import contextReducer from './contextReducer';
const initialState= JSON.parse(localStorage.getItem('transactions')) || []; 

export const ExpenseTrackerContext=  createContext(initialState);

export const Provider= ({ children }) => {
    //Logic for adding and deleting transaction
    //usereducer is a hook, basically it is a usestate but with a complex structure
    const [transactions, dispatch] = useReducer(contextReducer, initialState);
    // Action Creators
    
    const deleteTransaction = (id) => {
     dispatch({ type: 'DELETE_TRANSACTION', payload: id });
   };
 
   const addTransaction = (transaction) => {
     dispatch({ type: 'ADD_TRANSACTION', payload: transaction });
   };
   const balance = transactions.reduce((acc, currVal)=> {
     return (currVal.type==='Expense')? acc- currVal.amount: acc+ currVal.amount;
   }, 0);
    return (
       <ExpenseTrackerContext.Provider value={{ 
            deleteTransaction,
            addTransaction,// the if the property has same key and value we can simply write shorthand
            transactions, 
            balance
            
       }}>
            {children}
       </ExpenseTrackerContext.Provider>
    );
}
